import {
  CButton,
  CCol,
  CContainer,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from "@coreui/react";
import { useState } from "react";
import { Spinner } from "react-bootstrap";
import { confirmReceiptDraft } from "../../api/receipt";
import { SUCCESS } from "../../utils/constants/tags";
import { errorAlert } from "../utils/messages";
import { Receipt } from "../../models/receipt";

interface ReceiptConfirmDraftModalProps {
  show: boolean;
  receipt?: Receipt;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const ReceiptConfirmDraftModal: React.FC<ReceiptConfirmDraftModalProps> = ({
  show,
  receipt,
  onCancel,
  onSuccess,
}) => {
  const [submitting, setSubmitting] = useState(false);

  const onConfirmClick = async () => {
    if (receipt !== undefined) {
      setSubmitting(true);
      const requestStatus = await confirmReceiptDraft(receipt.id!);

      if (requestStatus.status !== SUCCESS) {
        const msg = requestStatus.detail ?? "Error al confirmar el borrador";
        errorAlert(msg);
      } else {
        onSuccess();
      }

      setSubmitting(false);
    }
  };

  return (
    <CModal show={show} className="modal-success" onClosed={onCancel} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>Confirmar Borrador</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          <CRow>
            <CCol sm="12">
              <h2>¿Estás seguro que deseas confirmar este borrador?</h2>
            </CCol>
          </CRow>
          <CRow>
            <CCol sm="12">
              <h5 className="mt-3">
                La fecha del recibo será actualizada a la fecha actual al
                confirmar.
              </h5>
            </CCol>
          </CRow>
        </CContainer>
      </CModalBody>
      <CModalFooter>
        <CButton disabled={submitting} onClick={onConfirmClick} color="success">
          {submitting ? (
            <Spinner
              animation="grow"
              style={{
                height: "17px",
                width: "17px",
                marginTop: "auto",
                marginBottom: "auto",
                marginRight: "10px",
              }}
            />
          ) : (
            <></>
          )}
          {submitting ? "Confirmando..." : "Confirmar"}
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default ReceiptConfirmDraftModal;
